import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=2fa1fa07&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"
import style0 from "./Letter.vue?vue&type=style&index=0&id=2fa1fa07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1fa07",
  null
  
)

export default component.exports